import type { NotificationSettings } from '../types';

export const notificationSettings: NotificationSettings = {
  // General settings
  enabled: true,
  quietHours: {
    enabled: false,
    start: '22:00',
    end: '06:00' // Dan wakes up at 6:00 AM
  },
  
  // Frequency controls
  maxPerHour: 100,
  maxPerDay: 1000,
  batchSimilar: true,
  
  // Types - tailored to Dan's focus areas
  scheduleReminders: true, // Important for his daily routine
  deadlineWarnings: true, // Critical for goals and financial planning
  taskSuggestions: true, // Help optimize his productivity
  breakReminders: true, // Important during strength training
  achievementCelebrations: true, // Motivate progress on aspirations
  
  // Timing preferences
  advanceNoticeMinutes: 15, // Enough time to prepare for workouts
  snoozeDefaultMinutes: 10,
  
  // Smart features
  contextAware: true,
  learningEnabled: true,
  adaptiveTimingEnabled: true,
  
  // Presentation
  soundEnabled: true,
  vibrationEnabled: true,
  showOnLockScreen: true,
  priorityFiltering: 'medium_high', // Focus on important notifications
  
  // Working hours integration - Dan's software engineering schedule
  respectWorkingHours: true,
  workingHours: {
    monday: { start: '08:30', end: '17:30', enabled: true },
    tuesday: { start: '08:30', end: '17:30', enabled: true },
    wednesday: { start: '08:30', end: '17:30', enabled: true },
    thursday: { start: '08:30', end: '17:30', enabled: true },
    friday: { start: '08:30', end: '16:30', enabled: true }, // Early finish Friday
    saturday: { start: '10:00', end: '14:00', enabled: false }, // Family time
    sunday: { start: '10:00', end: '14:00', enabled: false } // Family time
  }
};